export const formatDiscountPercentage = (discountPercentage?: number) => {
  if (!discountPercentage) return '';
  switch (discountPercentage) {
    case 50:
      return 'half price';
    case 100:
      return 'free';
    default:
      return `${discountPercentage}%`;
  }
};
